import { toFieldSummary } from "./zoho";

export const fieldKey = (field) => `${field.api_name}__${field.data_type}`;

/**
 * Compare a module's current Zoho fields against the fields already saved
 * for syncing.
 *
 * Returns:
 *  - availableModuleFields: Zoho fields not yet selected for sync
 *  - markedDatabaseFields:  saved fields flagged with `field_exist_in_zoho`
 *    (false when the field has since been removed from the Zoho module)
 */
export const diffModuleAndDatabaseFields = (moduleFields, databaseFields) => {
  const selectedFields = {};
  (databaseFields || []).forEach((field) => {
    selectedFields[fieldKey(field)] = field;
  });

  const moduleFieldsByKey = {};
  const availableModuleFields = [];

  (moduleFields || []).forEach((field) => {
    const summary = toFieldSummary(field);
    if (!selectedFields[fieldKey(field)]) {
      availableModuleFields.push({ ...summary, field_exist_in_zoho: true });
    }
    moduleFieldsByKey[fieldKey(field)] = summary;
  });

  const markedDatabaseFields = (databaseFields || []).map((field) => ({
    ...field,
    field_exist_in_zoho: Boolean(moduleFieldsByKey[fieldKey(field)]),
  }));

  return { availableModuleFields, markedDatabaseFields };
};
